export default {"src":"/_next/static/media/cherry-logo.2e5602c4.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};